import React from 'react';
import ReactDOM from 'react-dom';

import FormLogin from '../auth/components/forms/FormLogin.jsx';

const root = document.getElementById('form-login');

if (root) {
  ReactDOM.render((
    <div>
      <FormLogin
        title="學生或老師登入"
        router={false}
      />
    </div>
  ), root);
}
